import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import createSagaMiddleware from 'redux-saga';
import allReducers from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware({
  onError(error) {
    setTimeout(() => {
      throw error;
    }, 0);
  }
});

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  stateTransformer: () => ({})
});

const store = configureStore({
  reducer: allReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // we are using callbacks in sagas that are not serializable
      // this should be specific to those callbacks only, not a general disable
      serializableCheck: false
    }).concat(sagaMiddleware),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer)
});

sagaMiddleware.run(rootSaga);

export default store;
